/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import CardVendor from '../../components/card-vendor'
import icOne from '../../static/icons/vendor/clean/ic-1.svg'
import icTwo from '../../static/icons/vendor/clean/ic-2.svg'
import icThree from '../../static/icons/vendor/clean/ic-3.svg'
import { TitleTwo, TextBodyOne } from '../../components/text'
import { Style } from './vendor.styles'

const VendorFix = () => {
  const { t } = useTranslation();

  return (
    <Style>
      <Grid>
        <Row middle="lg">
          <Col lg={6} sm={12} xs={12} md={12}>
            <Row className="column-top">
              <Col lg={12} sm={12} xs={12} md={12}>
                <div className="bottom-margin">
                  <TitleTwo style={{ textTransform: 'uppercase' }}>
                    {t('pageJasaCleaningService.part17')}
                  </TitleTwo>
                  <TitleTwo style={{ textTransform: 'uppercase' }}>
                    {t('pageJasaCleaningService.part18')}
                  </TitleTwo>
                </div>
                <TextBodyOne>
                  {t('pageJasaCleaningService.part19')}
                </TextBodyOne>
              </Col>
            </Row>
          </Col>
          <Col lg={6} sm={12} xs={12} md={12}>
            <Row className="column-top">
              <Col lg={4} sm={3} xs={6} md={4} className="bottom-margin-column">
                <CardVendor title={t('pageJasaCleaningService.part20')} image={icOne}></CardVendor>
              </Col>
              <Col lg={4} sm={3} xs={6} md={4} className="bottom-margin-column">
                <CardVendor
                  styleImg={{ height: 88 }}
                  title={t('pageJasaCleaningService.part21')}
                  image={icTwo}
                ></CardVendor>
              </Col>
              <Col lg={4} sm={3} xs={6} md={4} className="bottom-margin-column">
                <CardVendor
                  title={t('pageJasaCleaningService.part22')}
                  image={icThree}
                ></CardVendor>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default VendorFix
